import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "StatusBarItems" */ "./lazyIndex"), { name: "StatusBarItems" });

export const LazyStatusBarReminders: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarReminders);

export const LazyStatusBarZoom: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarZoom);
